import {RemoteGisCrudService} from '../../core/services'

export class AppRemoteGisCrudService extends RemoteGisCrudService {}
